module.exports = __webpack_public_path__ + "media/images/photos/error-f52dcc6164ab99827f04abd08def4992.jpg";